var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#273B7A"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M506.239,310.165L349.717,153.641l-130.493,10.416l-66.658,60.85l8.554,132.367l148.202,149.147 C407.63,485.591,485.086,408.35,506.239,310.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4285F4"
    },
    d: "M261.584,232.469v49.055h76.717c-10.88,35.116-43.608,60.623-82.298,60.623 c-47.578,0-86.149-38.569-86.149-86.149c-0.002-47.576,38.567-86.147,86.145-86.147c22.235,0,42.436,8.497,57.72,22.326 l35.997-38.538c-24.693-22.619-57.589-36.431-93.717-36.431c-76.652,0-138.792,62.138-138.792,138.792S179.347,394.792,256,394.792 S394.792,332.653,394.792,256c0-8.03-0.741-15.879-2.06-23.531H261.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA4335"
    },
    d: "M256,169.853c22.235,0,42.436,8.497,57.72,22.326l35.997-38.538 c-24.693-22.621-57.589-36.433-93.717-36.433c-53.157,0-99.311,29.896-122.625,73.778l42.356,33.921 C188.213,192.717,219.401,169.853,256,169.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBC05"
    },
    d: "M169.855,256c0-10.978,2.132-21.437,5.877-31.092l-42.356-33.921 c-10.305,19.397-16.167,41.517-16.167,65.014c0,23.605,5.911,45.825,16.305,65.286l42.105-34.504 C171.951,277.209,169.855,266.861,169.855,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34A853"
    },
    d: "M303.895,327.547c-13.702,9.192-30.153,14.601-47.892,14.601c-36.719,0-67.986-23.012-80.386-55.367 l-42.105,34.504c23.362,43.735,69.441,73.506,122.487,73.506c34.451,0,65.943-12.579,90.207-33.358L303.895,327.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4285F4"
    },
    d: "M394.792,256c0-8.03-0.741-15.879-2.06-23.531H261.584v49.055h76.717 c-5.891,19.016-18.225,35.166-34.406,46.023l42.312,33.887C375.932,335.977,394.792,298.203,394.792,256z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.12a1213efb73cf43ab6be92fd099539e.svg";
export { ForwardRef as ReactComponent };